import PropTypes from 'prop-types'

import { PillRow, Pill } from './styled'

// Shown on a brand-new chat. Static starters for now; can be swapped for
// backend-provided suggestions once that contract is finalized.
export const DEFAULT_SUGGESTIONS = [
  'How am I tracking toward retirement?',
  'How much should I be saving?',
  'Explain my recommended investment mix',
  'What happens if I retire earlier?',
]

const SuggestionPills = ({ suggestions = DEFAULT_SUGGESTIONS, onSelect, stacked, disabled }) => {
  if (!suggestions.length) return null

  return (
    <PillRow stacked={stacked}>
      {suggestions.map(text => (
        <Pill key={text} type='button' disabled={disabled} onClick={() => onSelect?.(text)}>
          {text}
        </Pill>
      ))}
    </PillRow>
  )
}

SuggestionPills.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  /** Stack one pill per row, right-aligned (in-chat follow-ups). */
  stacked: PropTypes.bool,
  /** Dim and block the pills — e.g. while a response is still streaming. */
  disabled: PropTypes.bool,
}

export default SuggestionPills
